export default (set, get, data) => set(
  () => ({
    design: {
      ...get().design,
      ...data
    }
  }),
  false,
  { type: 'UPDATE', data }
);
